import {
  Icon,
  IconProps,
  Input,
  InputGroup,
  InputRightElement,
  InputRightElementProps,
} from "@chakra-ui/react";
import { useFormikContext } from "formik";
import { get } from "lodash";
import { useCallback, useState } from "react";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { RiEyeCloseLine } from "react-icons/ri";

interface EncryptedInputFieldProps {
  name: string;
  inputRightElementProps?: InputRightElementProps;
  inputIconProps?: IconProps;
  autoComplete?: string;
}

function EncryptedInputField({
  name,
  inputRightElementProps,
  inputIconProps,
  ...props
}: EncryptedInputFieldProps) {
  const { values } = useFormikContext();
  const [show, setShow] = useState(false);

  const handleClick = useCallback(() => setShow((prev) => !prev), []);
  return (
    <InputGroup size="md">
      <Input
        name={name}
        value={get(values, name, "")}
        autoComplete={show ? "on" : "off"}
        {...props}
        type={"text"}
        className={`${show ? "" : "password-mask"}`}
      />
      <InputRightElement
        display="flex"
        alignItems="center"
        mt="4px"
        {...inputRightElementProps}
      >
        <Icon
          _hover={{ cursor: "pointer" }}
          as={show ? RiEyeCloseLine : MdOutlineRemoveRedEye}
          {...inputIconProps}
          onClick={handleClick}
        />
      </InputRightElement>
    </InputGroup>
  );
}

export default EncryptedInputField;
